<template>
    <v-row v-if="$rc.inIndustry('wine')" class="my-1">
        <v-col cols="12">
            <v-alert
                type="error"
                class="shaded-light"
                border="left"
                colored-border
            >
                <div>
                    <slot name="title">
                        <strong>Emerging Carrier Issue</strong>
                        
                        <p
                            style="margin-top: 5px"
                        >
                            About two weeks ago, we were notified of unusual carrier blocks affecting three wineries in rapid succession. 
                            All originated from a single aggregator in the messaging ecosystem. 
                            When a winery is blocked, all of that winery's messaging through that aggregator is suspended until resolved — 
                            not just promotional messages — which can interrupt other important communications.
                        </p>

                        <p>
                            <b>Current status:</b> Messaging has been restored for the affected wineries, and we have not seen additional blocks.
                        </p>

                        <p>
                            <b>What to do now:</b>
                            <ul>
                                <li>If your next promotional message can wait, consider delaying briefly while we gather more clarity.</li>
                                <li>If it can’t wait, consider using indirect promotional language.</li>
                                <li>Watch for an upcoming RedChirp prompt to begin toll-free number registration, which can provide an alternative messaging path.</li>
                            </ul>
                        </p>

                        <a href="https://redchirp.com/emerging-carrier-issue-updates-week-of-jan-5th/" target="_blank">Read the full update for details, examples, and next steps.</a>


                    </slot>
                </div>
            </v-alert>
        </v-col>
    </v-row>
</template>

<script>
/*import WineryCarrierAlertContent from '@/components/bulk/winery-carrier-alert-content.vue';*/

export default {
    name: 'TempDisableWineriesFromScheduling',

    /*components: {
        WineryCarrierAlertContent,
    },*/

    data() {
        return {
            show_details: false,
        };
    },
};
</script>

<style lang="scss" scoped>
a {
    color: var(--v-primary-base) !important;
    text-decoration: none;
}
</style>